import { StyleSheet, View } from 'react-native';
import { TrendingUp } from 'lucide-react-native';
import type { PhotoSearchKnowledgeImpactViewModel } from '../../types/photoSearch';
import { tokens } from '../../theme/tokens';
import { AppText } from '../ui/AppText';

type KnowledgeUpdateSummaryProps = {
  impacts: PhotoSearchKnowledgeImpactViewModel[];
};

export function KnowledgeUpdateSummary({ impacts }: KnowledgeUpdateSummaryProps) {
  if (!impacts.length) {
    return null;
  }

  return (
    <View style={styles.wrapper}>
      <View style={styles.header}>
        <TrendingUp size={16} color={tokens.colors.success} />
        <AppText variant="body" weight="bold">
          知识点更新
        </AppText>
      </View>
      {impacts.map((impact) => (
        <View key={impact.id} style={styles.impactRow}>
          <View style={styles.impactCopy}>
            <AppText variant="caption" weight="bold">
              {impact.subject} · {impact.knowledgePoint}
            </AppText>
            <AppText variant="caption" tone="muted">
              {impact.beforeStatus}
              {' -> '}
              {impact.afterStatus}
            </AppText>
          </View>
          <AppText variant="caption" tone="success" weight="bold">
            {impact.changeLabel}
          </AppText>
        </View>
      ))}
    </View>
  );
}

const styles = StyleSheet.create({
  wrapper: {
    gap: tokens.spacing.sm,
    borderRadius: tokens.radius.md,
    padding: tokens.spacing.md,
    backgroundColor: tokens.colors.successSoft,
  },
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: tokens.spacing.sm,
  },
  impactRow: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: tokens.spacing.md,
  },
  impactCopy: {
    flex: 1,
  },
});
